import { User } from "oidc-client-ts";
import { appSettings } from "../appSettings";

/**
 * @description Construct the base URL say https://localhost:3000/
 *
 * @returns {string}
 */
export const getBaseURL = (): string => {
  /*
      ********************************************************************************
          window.location.protocol ==> Will give you whether it is http or https
          window.location.hostname ==> Will give you the domain name
      ********************************************************************************
      */
  let uri = `${window.location.protocol}//${window.location.hostname}`;

  /*
      ********************************************************************************
          If the uri contains localhost as domain then add port no.
      ********************************************************************************
      */
  if (uri.includes("localhost")) {
    uri = `${uri}:${window.location.port}`;
  }
  return uri;
};

/**
 *
 * @param {User} _user
 * @returns {void}
 */
export const onSignIn = (_user: User | null): void => {
  // Get the current URL
  const currentUrl = window.location.href;

  // Remove everything from and after '/callback' (case-insensitive)
  const callbackIndex = currentUrl.toLowerCase().indexOf("/callback");
  const baseUrl = callbackIndex !== -1 ? currentUrl.substring(0, callbackIndex) : currentUrl;

  // Replace the current state without redirecting
  window.history.replaceState({}, document.title, baseUrl);
};

/**
 * @returns {void}
 */
export const onSignOut = (): void => {
  // Redirect to the session endpoint url
  const endSessionEndpoint = appSettings.OIDC_END_SESSION_ENDPOINT;

  if (endSessionEndpoint) {
    window.location.replace(endSessionEndpoint);
  } else {
    console.error("OIDC_END_SESSION_ENDPOINT is not defined");
  }
};
